'use client';

import React from 'react';

export default function Loading() {

	return (
		<div className="loaderContainer">
			<div className='loader'></div>
		</div>
	);
}
